import { assignArrayKeys } from "../copy-selected-fields-action/remove-keys";

export const CLONE_CONTENT_CONFIG = {
  cruise: {
    excludedFields: ["data", "cruiseCode", "arrivalDate", "metadata"]
  },
  specialVoyage: {
    excludedFields: [
      "data",
      "cruiseCode",
      "metadata",
      "segments",
      "isVisible",
      "uniquePortsCount",
      "uniqueCountriesCount"
    ]
  }
} satisfies Record<string, { excludedFields: string[] }>;

export type ClonableType = keyof typeof CLONE_CONTENT_CONFIG;

export const isClonableType = (type: string): type is ClonableType =>
  type in CLONE_CONTENT_CONFIG;

export type ClonableField = { name: string; readOnly?: unknown };

export type ContentPatch = {
  set: Record<string, unknown>;
  unset: string[];
};

export const isSystemField = (name: string) => name.startsWith("_");

export const isContentField =
  (excludedFields: string[]) =>
  ({ name, readOnly }: ClonableField) =>
    !isSystemField(name) && !excludedFields.includes(name) && readOnly !== true;

const isEmpty = (value: unknown) => value === undefined || value === null;

export const cloneContent = (
  source: Record<string, unknown>,
  fields: ClonableField[],
  excludedFields: string[]
): ContentPatch =>
  fields
    .filter(isContentField(excludedFields))
    .reduce<ContentPatch>(
      ({ set, unset }, { name }) =>
        isEmpty(source[name])
          ? { set, unset: [...unset, name] }
          : { set: { ...set, [name]: assignArrayKeys(source[name]) }, unset },
      { set: {}, unset: [] }
    );
